import React from 'react';
import { HdIcon } from '../../../components';
import styles from './GlobalSearchFooter.module.scss';
import { isMac } from '../../../core/utils/user-agent';

export function GlobalSearchFooter() {
  return (
    <div className='dialog-footer justify-center'>
      <div className={styles.keyCombination}>
        <div className={styles.iconContainer}>
          <HdIcon name='navigation-indicator' className={styles.key} size={1} />
        </div>

        <span className={styles.keyAction}>to Navigate</span>
      </div>

      <div className={styles.keyCombination}>
        <div className={styles.iconContainer}>
          <HdIcon name='enter' className={styles.key} size={1} />
        </div>

        <span className={styles.keyAction}>to Select</span>
      </div>

      <div className={styles.keyCombination}>
        <div className={styles.iconContainer}>
          <HdIcon name='esc' className={styles.key} size={2} />
        </div>

        <span className={styles.keyAction}>to Dismiss</span>
      </div>

      <div className={styles.keyCombination}>
        <div className={styles.iconContainer}>
          <HdIcon name={isMac() ? 'cmd' : 'ctrl'} size={1} className={styles.key} />
        </div>

        <div className={`${styles.iconContainer} ml-1`}>
          <span className={`${styles.key} icon-size-0`}>/</span>
        </div>

        <span className={styles.keyAction}>Shortcuts</span>
      </div>
    </div>
  );
}
